<template>
	<div class="vip" :style="{
			  padding: `${styles.paddingY}px ${styles.paddingX1}px  ${styles.paddingY1}px  ${styles.paddingX}px`,
              background: styles.zubackground,
            }">
		<div :style="setStyle()" class="vip_head flex_c">
			<img class="vip_head_img" :src="styles.icon" ></img>
			<div class="vip_head_title" :style="{color:styles.color}">{{params.title}}</div>
			<div class="vip_head_hr" :style="{background:styles.color}"></div>
			<div class="vip_head_tips" :style="{color:styles.color}">{{params.tips}} </div>
			<!-- <uni-icons type="right" size="12" style="margin-top: -2rpx;" color="#6E2200"></uni-icons> -->
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			styles:{
				type:Object
			},
			// 标签文字
			params: {
				type:Object
			},
		},
	  data() {
	    return {
	    }
	  },
	  /**
	   * 生命周期函数--监听页面加载
	   */
	  onLoad(options) {
		
	  },
		created() {
		},
	  methods: {
		setStyle(){
			let _this = this
			if(_this.params.type == '2'){
				return {
					background:_this.styles.background,
					borderRadius: _this.styles.borderRadius+'px '+_this.styles.borderRadius+'px ',
					}
			}else if(_this.params.type == '1'){
				return {
					backgroundImage:'url('+_this.styles.backgroundimg+')',
					backgroundPosition:'center',
					backgroundSize:' 100% auto',
					borderRadius: _this.styles.borderRadius+'px '+_this.styles.borderRadius+'px ',
				}
			}
		}
	  }
	}
</script>

<style lang="scss" scoped>
	.vip{
		&_head{
			height: 41px;
			padding-left: 10px;
			border-radius: 10px;
			&_img{
				width: 16px;
				height: 16px;
				display: block;
				margin-right: 4px;
			}
			&_title{
				font-weight: bold;
				color: #6E2200;
				font-size: 15px;
			}
			&_hr{
				margin: 0 7px;
				width: 1px;
				height: 14px;
				opacity: 0.2;
			}
			&_tips{
				font-size: 10px;
				color: #6E2200;
			}
		}
	}
</style>